import React, { Component } from 'react';
import { Link } from 'react-router';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Cookies from 'universal-cookie';
import { fetch_kolrankingPost } from '../actions/fetch_kolranking';
import RaisedButton from 'material-ui/RaisedButton';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import LoadingBoxes from '../components/loadingBoxes';
import LoadingText from '../components/loadingText';
import Kol_ranking_table from '../components/kol_ranking_table';
import { checkProfilePic, encodeUrl } from '../utility/tool';
import { userLogout } from '../utility/logout';
import '../styles/kol.css';
import icon_user60 from "../imgs/icons8-user-60.png";

let cookies = new Cookies();

const CompareInlineStyle = {
	kolTableLong: {
		width: '220px',
		display: 'inline-block',
		fontSize: '14px',
		margin: '5px',
	},
	kolTableShort: {
		width: '205px',
		display: 'inline-block',
		fontSize: '14px',
		margin: '5px',
	},
	fontFamily: {
		fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"',
	},
	tableHeader: {
		border: 'none',
	},
	tableRow: {
		borderBottom: '1px solid #cdcdcd',
	},
	tableRowColumnLong: {
		textAlign: 'left',
		width: '85%',
		backgroundColor: '#ffe8ca',
		borderRight: '1px solid #cdcdcd',
	},
	tableRowColumnShort: {
		textAlign: 'left',
		width: '15%',
		backgroundColor: '#ffe8ca',
	},
	tableRowColumnFull: {
		textAlign: 'left',
		width: '100%',
		backgroundColor: '#ffe8ca',
	},
	fans_image_style: {
		verticalAlign: 'top',
		display: 'inline-block',
		width: '50px',
		height: '50px',
		marginRight: '6px',
		border: '1px solid gray',
		borderRadius: '2px',
		boxShadow: '0 1px 2px #666',
	},
	tableCellLong: {
		width: '100%',
		wordWrap: 'break-word',
	},
	tableCellShort: {
		width: '85%',
	},
	tableCellValue: {
		whiteSpace: 'normal',
		width: '15%',
		textAlign: 'center',
	},
}

class Compare extends Component {
	constructor(props) {
		super(props)
	}

	componentDidMount() {
		window.scrollTo(0, 0)

		const { location } = this.props
		const { group_name, ...newQuery } = location.query

		if (location.query.kols.length) {
			this.props.fetch_kolrankingPost(newQuery, cookies.get('token'))
		}

	}

	renderKolTable(title, type) {
		const { kolranking } = this.props;
		let resultTable

		return (
			<div className="kolTable" style={type === 'leader_value' ? CompareInlineStyle.kolTableLong : CompareInlineStyle.kolTableShort}>
				<div className="rankingTable">
					<div className="kolTableTitle">{title}</div>
					<Table selectable={false} style={CompareInlineStyle.fontFamily}>
						<TableHeader adjustForCheckbox={false} displaySelectAll={false} style={CompareInlineStyle.tableHeader}>
							{this.renderTableRow(type)}
						</TableHeader>
						<TableBody displayRowCheckbox={false}>
							{this.renderTableBody(kolranking[type], type)}
						</TableBody>
					</Table>
				</div>
			</div>
		)

	}

	renderTableRow(type) {
		if (type === 'leader_value') {
			return (
				<TableRow style={CompareInlineStyle.tableRow}>
					<TableRowColumn className="tableHeaderColumn" style={CompareInlineStyle.tableRowColumnLong}>KOL排名</TableRowColumn>
					<TableRowColumn className="tableHeaderColumn" style={CompareInlineStyle.tableRowColumnShort}>KD</TableRowColumn>
				</TableRow>
			)
		} else {
			return (
				<TableRow style={CompareInlineStyle.tableRow}>
					<TableRowColumn className="tableHeaderColumn" style={CompareInlineStyle.tableRowColumnFull}>KOL排名</TableRowColumn>
				</TableRow>
			)
		}
	}

	renderTableBody(data, type) {
		if (data) {
			return (
				data.map((el, idx) => {
					let queryString = `/meta?fid=${el.fid}`
						+ `&tags=`
						+ `&skills=`
						+ `&jobs=`
						+ `&fans_min=500`
						+ `&fans_max=30000000`
						+ `&period=30`
						+ `&sex=0,1,2`
						+ `&source=FB,YT,IG`
						+ `&kol_name=`
						+ `&cat_op=or`

					return (
						<TableRow key={el.fid} className="fansPostTableRow">
							<TableRowColumn className="tableCell picture cursorPointer" style={type === 'leader_value' ? CompareInlineStyle.tableCellShort : CompareInlineStyle.tableCellLong}>
								<a href={encodeUrl(queryString)} className="tableCellLink">
									<img src={checkProfilePic(el)} style={CompareInlineStyle.fans_image_style} onError={(e) => { e.target.onerror = null; e.target.src = icon_user60 }} />
									<span className="leaderName">{el.name}</span>
								</a>
								<span className="rankNum">{idx + 1}</span>
							</TableRowColumn>
							{this.renderLeaderValue(el, type)}
						</TableRow>
					)
				})
			)
		}
	}

	renderLeaderValue(el, type) {
		if (type === 'leader_value') {
			return <TableRowColumn className="tableCell totalNum" style={CompareInlineStyle.tableCellValue}>{Math.round(el.value)}</TableRowColumn>
		}
	}

	render() {
		const {
			location,
			kolranking,
			kolranking_isloading,
			kolranking_error
		} = this.props;

		if (!location.query.kols.length) {
			return (
				<div className="errormsg">
					<p className="errormsgCenter">請重新點選KOL</p>
					<Link to="/" className="refreshBtn">
						<span className="refreshIconText">點我去首頁</span>
					</Link>
				</div>
			)
		}

		if (kolranking_isloading) {
			return (
				<div>
					<LoadingBoxes />
					<LoadingText />
				</div>
			)
		}

		if (kolranking === null) {
			return (
				<div className="errormsg">
					<p className="errormsgCenter">查無資料，請重新搜尋</p>
					<Link to="/" className="refreshBtn">
						<span className="refreshIconText">點我去首頁</span>
					</Link>
				</div>
			)
		}

		if (kolranking_error !== false) {
			if (kolranking_error.status === 401) {
				setTimeout(function () { userLogout(); }, 3000);
				return <p className="errormsg">您的登入期間已過期，請重新登入</p>;
			} else {
				return (
					<div className="errormsg">
						<p className="errormsgCenter">資料未完成載入，請稍後再試</p>
						<div className="refreshBtn" onClick={() => this.resetQueryInfo()}>
							<span className="refreshIcon"></span>
							<span className="refreshIconText">重新整理</span>
						</div>
					</div>
				)
			}
		}

		return (
			<div className="compareWrapper">
				<div className="goBackBox" onClick={browserHistory.goBack}>
					<span className="icon_return"></span>
					<p className="message">Back</p>
				</div>
				<div className="kol_ranking">
					{this.renderKolTable('領袖價值', 'leader_value')}
					{this.renderKolTable('曝光數最多', 'fans_scale')}
					{this.renderKolTable('粉絲成長數', 'growth')}
					{this.renderKolTable('互動最熱絡', 'performance')}
					{this.renderKolTable('主題最相關', 'relevance')}
				</div>
			</div>
		)
	}

}

function mapStateToProps({ kolranking, kolranking_isloading, kolranking_error }) {
	return { kolranking, kolranking_isloading, kolranking_error };
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ fetch_kolrankingPost }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Compare);



// WEBPACK FOOTER //
// ./src/containers/compare.js